import React from "react";
import Wrapper from "../assets/wrappers/HowItWorksWrapper";
import AIIcon from "../assets/images/icons/ai-chip-3d-icon-artificial-intelligence.png";
import SocialMediafrom from "../assets/images/icons/rendering-social-media-marketing-icon.png"
import Mom from "../assets/images/icons/mom.png"

import Arrow1 from "../assets/images/icons/bigArrowRightTilt1.png";
import Arrow2 from "../assets/images/icons/bigArrowRightTilt2.png";

const HowItWorks: React.FC = () => {
  return (
    <Wrapper>
      <div className="row items-center box-shadow1 mt-3">
        <div className="step upload-media">
          <h4>Upload Media</h4>
          <p>
            Upload Sabhas videos or audio recordings in various formats like MP4, WAV, MP3, and M4A.
          </p>
          <img src={SocialMediafrom} alt="Social Media from" />
        </div>

        <div className="arrow">
          <img src={Arrow1} alt="Arrow 1" />
        </div>

        <div className="step ai-processing">
          <h4>AI Processing</h4>
          <p>
            Automatic transcription, multilingual translation using Bhashini and understanding the context of the meeting.
          </p>
          <img src={AIIcon} alt="AI Processing Icon" />
        </div>

        <div className="arrow">
          <img src={Arrow2} alt="Arrow 2" />
        </div>

        <div className="step getMom">
          <h4>Get Minutes</h4>
          <p>Generation of structured Minutes of Meeting (MoM) in multiple languages.</p>
          <img src={Mom} alt="Get Minutes Icon" />
        </div>
      </div>
    </Wrapper>
  );
};

export default HowItWorks;
